export default __webpack_public_path__ + "static/media/Image.119fb9b0.png";